import React, { useState } from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SrButton, { SR_BUTTON_THEME_ADOBE_BLUE } from 'client/components/SrButton/SrButton';
import SrRenterHouseholdsModal from 'client/components/SrRenterHouseholdsModal';

import './HitlistTaskListRow.less';

const HitlistTaskListRowHousehold = ({ renter }) => {
  const [showHouseholdDashboard, setShowHouseholdDashboard] = useState(false);

  return (
    <div styleName="section">
      <span styleName="title">Household</span>
      <SrBox margin="20px 0" maxWidth="300px">
        <SrButton
          type="button"
          theme={SR_BUTTON_THEME_ADOBE_BLUE}
          onClick={() => setShowHouseholdDashboard(true)}
        >
          Open Legacy Household
        </SrButton>
      </SrBox>
      {showHouseholdDashboard && (
        <SrRenterHouseholdsModal
          renter={{ id: renter.id }}
          onClose={() => setShowHouseholdDashboard(null)}
          householdAdminsList={[]}
          reloadDataTableHousehold={() => {}}
        />
      )}
    </div>
  );
};

HitlistTaskListRowHousehold.propTypes = {
  renter: PropTypes.object.isRequired,
};

HitlistTaskListRowHousehold.displayName = 'HitlistTaskListRowHousehold';

export default HitlistTaskListRowHousehold;
